import { ReactNode, useState } from 'react'

import { useMediaQuery } from 'usehooks-ts'

import { Dialog, DialogTrigger } from '@/shared/ui/Dialog'
import { InfoPopover } from '@/shared/ui/InfoPopover'

import { OfferForShowPrice } from '../types/OfferForShowPrice'
import { OfferPriceContent } from './OfferPriceContent'
import { PriceDialogContent } from './PriceDialogContent'

interface PricePopoverOrDialogProps {
	offer: OfferForShowPrice
	children: ReactNode
}

export const PricePopoverOrDialog = ({
	children,
	offer
}: PricePopoverOrDialogProps) => {
	const [open, setOpen] = useState(false)
	const isMobile = useMediaQuery('(width < 640px)')
	return (
		<>
			{!isMobile && (
				<InfoPopover
					className="self-start"
					asChild
					content={<OfferPriceContent offer={offer} />}
				>
					{children}
				</InfoPopover>
			)}

			{isMobile && (
				<Dialog
					open={open}
					onOpenChange={setOpen}
				>
					<DialogTrigger asChild>{children}</DialogTrigger>

					<PriceDialogContent
						onClose={() => setOpen(false)}
						offer={offer}
					/>
				</Dialog>
			)}
		</>
	)
}
